import React from "react";
import { TableHead, TableRow, TableCell, Skeleton } from "@mui/material";
import colors from "assets/theme-dark/base/colors";

interface SkeletonHeaderProps {
  columnCount: number;
}

const SkeletonHeader: React.FC<SkeletonHeaderProps> = ({ columnCount }) => (
  <TableHead>
    <TableRow>
      {Array(columnCount)
        .fill(null)
        .map((_, index) => (
          <TableCell key={index} sx={{ border: `1px solid ${colors.grey[300]}`, padding: 1.5 }}>
            <Skeleton variant="rectangular" height={32} />
          </TableCell>
        ))}
    </TableRow>
  </TableHead>
);

export default SkeletonHeader;
